import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {ApiService} from '../../../services/api.service';
import {SweetalertService} from '../../../services/sweetalert.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public displayedColumns: string[] = ['id', 'name', 'options'];
  public proposals;
  public isLoading = false;

  constructor(
    public router: Router,
    private apiService: ApiService,
    private sweetalertService: SweetalertService,
  ) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.apiService.getLoggedPublisherProposals().subscribe((response: any) => {
      this.proposals = response.data;
      this.isLoading = false;
    }, error => {
      this.sweetalertService.connectionError();
    });
  }
}
